import type { ChatbotRepository } from "@core/domain/repositories/chatbot.repository";
import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository";
import { coreTypes } from "@core/root/core-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class ChatbotMessagesDeleteUseCase {
    constructor(
        @inject(coreTypes.repositories.ChatbotRepository)
        private readonly chatbotRepository: ChatbotRepository,
    ) {}
    async execute(): Promise<boolean> {
        const result = await this.chatbotRepository.deleteMessages();

        if (result.isErr()) {
            ToastManagerRepository.error(result.error.message);
        }

        return result.isOk();
    }
}
